/*eslint-disable*/
import React,{ useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import Axios from 'axios';

import APP_CONSTANTS from '../../config/constants';


const PurchaseOrderBranchDropdown = ({
        field: { name },
        form: { setFieldValue },
        branchData,
        getBranchSelected,
        ...props
    }) => {

    let options = []
    if (branchData && branchData.length > 0) {
        branchData.map((object, index) => {
            let temp = {}
            temp.key = object.vendorBranchCode
            temp.text = object.vendorBranchName
            temp.value = object.vendorBranchCode
            return options[index] = temp
        })
    }  

    const handleOnChange = (e, data) => {
        setFieldValue(name, data.value);
        getBranchSelected(data.value);
    }

    return (
        <Dropdown
            search
            selection
            onChange={(e, data) => handleOnChange(e, data)}
            options={options}
            {...props}
            fluid
        />
    )
}


export default PurchaseOrderBranchDropdown